import { ActionIcon, Badge, Fieldset, Group, Menu, Stack, Title } from '@mantine/core'
import { modals } from '@mantine/modals'
import { IconDots, IconDownload, IconMail } from '@tabler/icons-react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import ShibaButton from 'common/ShibaButton'
import OrderForm from 'components/orders/OrderForm'
import OrderHistoryTable from 'components/orders/OrderHistoryTable'
import { getOrderHistoryQuery, getOrderQueryOptions, useExportOrderToPdf } from 'hooks/orders'

export const Route = createFileRoute('/_auth/orders/details/$orderNumber')({
  loader: async ({ params, context: { queryClient } }) => {
    return Promise.all([
      await queryClient.ensureQueryData(getOrderQueryOptions(parseInt(params.orderNumber))),
      await queryClient.ensureQueryData(getOrderHistoryQuery('Z-' + params.orderNumber)),
    ])
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const params = Route.useParams()
  const { data: order } = useSuspenseQuery(getOrderQueryOptions(parseInt(params.orderNumber)))
  const { data: ordersHistory } = useSuspenseQuery(getOrderHistoryQuery('Z-' + params.orderNumber))
  const exportOrderToPdf = useExportOrderToPdf()
  const orderHistory = ordersHistory.find((history) => history.order.id === `Z-${order.id}`)

  function downloadOrderPdf(orderId: number) {
    exportOrderToPdf.mutate(orderId)
  }

  function openEmailsModal() {
    modals.openContextModal({
      modal: 'orderEmails',
      title: `Powiadomienia email dla zamówienia Z-${order.id}`,
      innerProps: {
        orderId: order.id,
      },
      size: 'lg',
    })
  }

  return (
    <Stack gap="xl">
      <Group justify="space-between">
        <Group gap="xs" align="center">
          <Title order={1}>Zamówienie Z-{order.id}</Title>
          {order.dispatchedAt && (
            <Badge size="lg" variant="light" color="green">
              Przesyłka wysłana
            </Badge>
          )}
        </Group>
        <Group gap="sm">
          <ShibaButton
            variant="light"
            onClick={() =>
              navigate({ to: '../../edit/$orderNumber', params: { orderNumber: order.id.toString() }, replace: true })
            }
          >
            Edytuj zamówienie
          </ShibaButton>
          <Menu shadow="md" width={200} position="bottom-end" withArrow arrowPosition="center">
            <Menu.Target>
              <ActionIcon variant="light" size="lg">
                <IconDots />
              </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item leftSection={<IconDownload size={14} />} onClick={() => downloadOrderPdf(order.id)}>
                Pobierz PDF
              </Menu.Item>
              <Menu.Item leftSection={<IconMail size={14} />} onClick={openEmailsModal}>
                Powiadomienia email
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Group>
      <OrderForm order={order} preview />
      {orderHistory && (
        <Fieldset legend="Historia zamówienia" mb="xl">
          <OrderHistoryTable data={orderHistory} />
        </Fieldset>
      )}
    </Stack>
  )
}
